export default __webpack_public_path__ + "static/media/background.6da6e8d1.png";